/*!
  _   _  ___  ____  ___ ________  _   _   _   _ ___   
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _| 
 | |_| | | | | |_) || |  / / | | |  \| | | | | || | 
 |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || |
 |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___|
                                                                                                                                                                                                                                                                                                                                       
=========================================================
* Horizon UI - v1.1.0
=========================================================

* Product Page: https://www.horizon-ui.com/
* Copyright 2023 Horizon UI (https://www.horizon-ui.com/)

* Designed and Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Chakra imports
import { Box, SimpleGrid } from '@chakra-ui/react';
import ChecklistTable from 'views/admin/checklistDetails/components/checklistSub/ChecklistTable';
import { columnsDataComplex } from 'views/admin/checklistDetails/variables/columnsData';
import React, { useEffect, useState, useCallback } from 'react';
import ChecklistService from '../../../services/ChecklistService';

export default function Settings() {

  const [error, setError] = useState('');

  const [tableDataComplex, setVehicleData] = useState([]);

  const getChecklistData =  useCallback(async () => {
    try {
      const checklistData = await ChecklistService.getAllChecklist(localStorage.getItem('token'));
      if (checklistData.status === 201 && checklistData.data.object) {

        const filteredData = checklistData.data.object.map(item => {
          let err = error;
          if(err){

          }
          let status = '';

          if(item.statusMap['Do Not Operate Machinery']){
            status = 'Do Not Operate Machinery';
          } else if(item.statusMap['Report & Proceed with Caution']){
            status = 'Report & Proceed with Caution';
          } else if(item.statusMap['Success']){
            status = 'Success';
          }

          return{
            id: item.id,
            rego: item.vehicle.registration,
            vinNumber: item.vehicle.vinNumber,
            model: item.vehicle.model,
            year: item.vehicle.year,
            category: item.vehicle.vehicleCategory.category,
            type: item.vehicle.vehicleType.type,
            mobileNumber: item.user.mobileNumber,
            status: status,
            options: ''
          };
      });
        setVehicleData(filteredData)
      } else {
        setError(checklistData.error);
      }
    } catch (error) {
      console.log(error);
      setError(error);
      setTimeout(() => {
        setError('');
      }, 5000);
    }
  }, [error]);

  // eslint-disable-next-line
  useEffect(() => {
    // eslint-disable-next-line
    getChecklistData()
   
  }, [getChecklistData]);

  

  // Chakra Color Mode
  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <SimpleGrid
        mb="20px"
        columns={{ sm: 1 }}
        spacing={{ base: '20px', xl: '20px' }}
      >
         {tableDataComplex && tableDataComplex.length > 0 ? (
        <ChecklistTable
          columnsData={columnsDataComplex}
          tableData={tableDataComplex}
        />
      ) : (
        <p>No checklist available</p> // Optional: message when no data is available
      )}
      </SimpleGrid>
    </Box>
  );
}
